// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__18JD9","search":"Settings_search__3OvY9","filter":"Settings_filter__1RFf0"};